/**
 * TextUtil.js
 * 
 * Created on 31-okt-2014, 9:54:31
 *
 * @author Harm Boschloo for Ranj
 * @author Ivo Swartjes for Ranj
 **/

import { isUndefined } from "../../util/TypeUtil";

export default class TextUtil {
    /**
     * Gets font size of a createjs.Text by parsing its font style
     * @param {createjs.Text} textField 
     * @returns {number} font size
     */
    static getFontSize(textField) {
        return TextUtil.getFontSizeFromStyle(textField.font);
    }
    
    /**
     * 
     * @param {string} fontStyle CSS font string
     * @returns {number} font size
     */
    static getFontSizeFromStyle(fontStyle) {
        return parseInt(TextUtil.REGEX_NUMBER.exec(fontStyle)[1]);
    }

    /**
     * Sets a new font size in the createjs.Text
     * 
     * @param {createjs.Text} textField 
     * @param {number} newSize 
     */
    static setFontSize(textField, newSize) {
        textField.font = TextUtil.setFontSizeInStyle(textField.font, newSize)
    }
    
    /**
     * Replaces the font size in a CSS font string with the given new size
     * @param {string} fontStyle CSS font string 
     * @param {number} newSize new font size
     * @returns {string} the CSS font with the new given size
     */
    static setFontSizeInStyle(fontStyle, newSize) {
        var newFont = fontStyle.replace(TextUtil.REGEX_NUMBER, newSize);
        return newFont;
    }
    
    
    /**
     * 
     * @param {createjs.Text} textField 
     * @returns {string} font name
     */
    static getFontName(textField) {
        return TextUtil.REGEX_FONT_NAME.exec(textField.font)[1];
    }
    
    /**
     * 
     * @param {createjs.Text} textField 
     * @param {number} textFieldHeight 
     */
    static centerTextVertically(textField, textFieldHeight) {
        if (isUndefined(textField.y0)) {
            textField.y0 = textField.y;
        }
        var textHeight = textField.getMeasuredHeight();
        textField.y = textField.y0 + textFieldHeight / 2 - textHeight / 2;
    }

    /**
     * 
     * @param {createjs.Text} textField 
     * @param {number} textFieldHeight 
     */
    static alignBottom(textField, textFieldHeight) {
        if (isUndefined(textField.y0)) {
            textField.y0 = textField.y;
        }
        var textHeight = textField.getMeasuredHeight();
        textField.y = textField.y0 + textFieldHeight - textHeight;
    }
}

TextUtil.REGEX_NUMBER = /^[^\d]*(\d+)/;
TextUtil.REGEX_FONT_NAME = /(?:.*px '?)([^']*)(?:'?)/i;